// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__2ZLCP","meals-appear":"AvailableMeals_meals-appear__ONwLi","htmlError":"AvailableMeals_htmlError__1R4ek","loading":"AvailableMeals_loading__3nkz1"};